import { ShopBuy } from "@/components/Bag";
import { CashOut, GodCashouts } from "@/components/CashOut";

export default function ShopPage() {
  return (
    <div className="max-w-md pb-16" data-testid="shop-page">
      <h1 className="font-head font-light text-4xl tracking-tighter mb-6" style={{ color: "var(--text-primary)" }}>Shop</h1>
      <p className="text-xs tracking-widest leading-relaxed mb-10 p-4" style={{ color: "var(--text-secondary)", border: "1px solid var(--border)" }} data-testid="shop-disclaimer">
        10% of all provision purchases go to mawilu &amp; company. The rest is held strictly for your cashouts, get out there and earn some provisions.
      </p>
      <ShopBuy />
      <CashOut />
      <GodCashouts />
    </div>
  );
}
